import {
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  ExpandableListItem,
  List,
  ListItem,
  Separator,
  useOverlay,
  Button,
} from '@fs/zion-ui'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { getUserRollbackSummary } from '../../../services/userService'
import { camelCaseToReadable } from '../../../util/StringUtil'
import DmcDataView from '../../common/DmcDataView'
import { UserContext } from '../UserContext'

export default function UserRollbackSummaryButtonAndDialog() {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentUser } = useContext(UserContext)
  const overlay = useOverlay()
  const [userRollbackSummary, setUserRollbackSummary] = useState()

  const closeOverlay = () => {
    setUserRollbackSummary()
    overlay.close()
  }

  const fetchAndDisplayData = async () => {
    try {
      const userRollbackSummaryResponse = await getUserRollbackSummary(currentUser.contributorId)
      setUserRollbackSummary(userRollbackSummaryResponse.data)
      overlay.open()
    } catch (err) {
      error(
        t('user.errors.retrievingUserRollbackSummary', {
          defaultValue: `Error retrieving user rollback summary: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  const summaryFields = userRollbackSummary
    ? Object.entries(userRollbackSummary).filter(([key]) => {
        return (
          key === 'earliest' ||
          key === 'latest' ||
          key === 'totalCommandsForRollback' ||
          key === 'totalCommandsTooOldForRollback'
        )
      })
    : []
  const actionsToTakeFields = userRollbackSummary
    ? Object.entries(userRollbackSummary).filter(([key]) => {
        return (
          key !== 'earliest' &&
          key !== 'latest' &&
          key !== 'totalCommandsForRollback' &&
          key !== 'totalCommandsTooOldForRollback'
        )
      })
    : []
  const summaryData = summaryFields.map(([key, value]) => {
    return {
      label: t(`user.rollback.summary.field.${key}`, camelCaseToReadable(key)),
      detail: value,
      key,
    }
  })

  return (
    <>
      <Button id="rollSumBtn" emphasis="medium" onClick={fetchAndDisplayData}>
        {t('user.rollback.summary.summary', 'Rollback Summary')}
      </Button>
      <DialogOverlay
        id="rollbackSummaryOverlay"
        {...overlay}
        title={t('user.rollback.summary.summary', 'Rollback Summary')}
        size="xxl"
      >
        {userRollbackSummary && (
          <>
            <DmcDataView data={summaryData} />
            <Separator size="xs" />
            <List>
              <ExpandableListItem primaryText={t('commands', 'Commands')} initiallyOpen>
                {actionsToTakeFields.map(([key, value]) => {
                  return <ListItem id={key} key={key} primaryText={key} secondaryText={value} />
                })}
              </ExpandableListItem>
            </List>
          </>
        )}

        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button emphasis="medium" onClick={closeOverlay}>
              {t('action.done', 'Done')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </>
  )
}
